import { translate } from '@lucidlink/uicore';
export const emailInviteValidationRules = (maxMembers) => {
    if (maxMembers !== undefined && maxMembers !== null) {
        return [
            {
                errorCodes: ['invitation.limitExceeded'],
                label: translate('Your current plan includes up to {{maxMembers}} members. To add more, upgrade your plan.', { maxMembers }),
            },
            {
                errorCodes: [
                    'invitation.emailFilters.email.format',
                    'invitation.emailFilters.empty',
                ],
                label: translate('Provide valid email addresses.'),
            },
        ];
    }
    else {
        return [
            {
                errorCodes: [
                    'invitation.emailFilters.email.format',
                    'invitation.emailFilters.empty',
                ],
                label: translate('Provide valid email addresses.'),
            },
        ];
    }
};
